<script lang="ts">
	import { WikiSearch, WikiSidebar } from '$lib/features/wiki';

	let { data, children } = $props();
</script>

<div class="wiki-shell container">
	<aside class="wiki-aside">
		<div class="aside-search">
			<WikiSearch records={data.searchRecords} />
		</div>
		<WikiSidebar sections={data.sidebar} />
	</aside>
	<main class="wiki-main">
		{@render children()}
	</main>
</div>

<style>
	.wiki-shell {
		display: grid;
		grid-template-columns: 220px minmax(0, 1fr);
		gap: 2.5rem;
		padding-top: 2rem;
		padding-bottom: 4rem;
	}
	.wiki-aside {
		position: sticky;
		top: 5rem;
		align-self: start;
	}
	.aside-search {
		margin-bottom: 1.25rem;
	}
	/* Breakpoint spójny z nav (marketing.css: 860px) — na mobile nawigacja
	   wiki żyje w Sheecie hamburgera (WikiHeader), nie w kolumnie. */
	@media (max-width: 860px) {
		.wiki-shell {
			grid-template-columns: minmax(0, 1fr);
			gap: 1.5rem;
		}
		.wiki-aside {
			display: none;
		}
	}
</style>
